'use client';
import {IBlock} from 'libs/types';
import {FC} from 'react';
import dynamic from 'next/dynamic';
import {IImagesData} from "../../../libs/types/page-home.types";

const SliderMDLazy = dynamic(() => import('./slider-md').then((mod) => mod.SliderMD));
const ListInfinityLazy = dynamic(() =>
    import('./list-infinity').then((mod) => mod.ListInfinity),
);
const SliderSMLzy = dynamic(() => import('./slider-sm').then((mod) => mod.SliderSM));
const ArticleLGLazy = dynamic(() => import('./article-lg').then((mod) => mod.ArticleLG));
const ArticleMDLazy = dynamic(() => import('./article-md').then((mod) => mod.ArticleMD));
const PlainHTMLLazy = dynamic(() => import('./plain-html').then((mod) => mod.PlainHTML));

interface IProps {
    data: IBlock;
    notAImage?:
        | {
        i16x7?: IImagesData | null;
        i16x9?: IImagesData | null;
        i4x3?: IImagesData | null;
        i1x1?: IImagesData | null
    }
        | undefined;
}

export const ParcelingItem: FC<IProps> = ({data, notAImage}) => {
    switch (data.templateKey) {
        /* Основной слайдер из больших слайдов картинок */
        case 'slider-md': {
            return <SliderMDLazy data={data}/>;
        }
        /* Слайдер средний используется для перечня программ */
        case 'slider-sm': {
            return <SliderSMLzy data={data}/>;
        }
        /* Экран перечесления карточек в АУДИОКНИГАХ */
        case 'list-infinity': {
            return <ListInfinityLazy data={data} notAImage={notAImage}/>;
        }
        /* Визуально отображение оформление книги и ее ui */
        case 'article-lg': {
            return <ArticleLGLazy data={data}/>;
        }
        case 'article-md': {
            return <ArticleMDLazy data={data}/>;
        }
        case 'plain-html': {
            return <PlainHTMLLazy data={data}/>;
        }
    }
};
